// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"624":"673dde2af1dba6ff","4416":"2fb9edaf4f4bc815","8485":"81feae11d031af02","9572":"69debcfbcfd0ac23"}[chunkId] + ".css";
};